import script from "./GestionTorneosView.vue?vue&type=script&setup=true&lang=ts"
export * from "./GestionTorneosView.vue?vue&type=script&setup=true&lang=ts"

import "./GestionTorneosView.vue?vue&type=style&index=0&id=0aee3966&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0aee3966"]])

export default __exports__